import React, { useCallback, useEffect } from "react";

import { Form, ValidState } from "./Form";
import { useDealActions } from "store";
import { useActionHook, useModals } from "hooks";
import { AsyncContentMui } from "components/Async-content/AsyncContentMui";
import { MeasureFee } from "store/types";

interface Props {
  feeId: number;
  dealId: number;
  refetchTable: () => void;
  onClose: () => void;
}

const buildInitialState = ({ source, amount, from_date, to_date }: MeasureFee): ValidState => {
  return {
    source,
    amount: amount.toString(),
    from_date: from_date,
    to_date: to_date
  };
};

export const Edit: React.FC<Props> = ({ feeId, dealId, refetchTable, onClose }) => {
  const { updateMeasureFeeAction, getMeasureFeesItemAction } = useDealActions();
  const { confirmModal } = useModals();

  const { action: getFee, data, loading } = useActionHook(getMeasureFeesItemAction);

  useEffect(() => {
    getFee(feeId);
  }, [feeId]);

  const handleSubmit = useCallback(
    async (validState: ValidState) => {
      try {
        const { show_override_modal } = await updateMeasureFeeAction({
          id: feeId,
          ...validState,
          override_existing: false
        });
        if (!show_override_modal) {
          refetchTable();
          onClose();
          return;
        }
        confirmModal({
          msg: "Please note the dates you have selected already have managed fees added, do you want to Override",
          title: "Fees data overriding",
          action: async () => {
            await updateMeasureFeeAction({
              id: feeId,
              ...validState,
              override_existing: false
            });
            refetchTable();
            onClose();
          }
        });
      } catch (error) {
        throw error;
      }
    },
    [feeId, refetchTable]
  );

  return (
    <AsyncContentMui isLoading={loading} spinnerProps={{ size: 100 }}>
      {!loading && data && (
        <Form dealId={dealId} onClose={onClose} onSubmit={handleSubmit} initialState={buildInitialState(data)} />
      )}
    </AsyncContentMui>
  );
};
